import { Expense } from "@finway-group/shared/lib/models"
import { DatePicker } from "antd"
import moment from "moment"
import React from "react"
import { useTranslation } from "react-i18next"
import { useDispatch } from "react-redux"

import { useCompany } from "Shared/hooks/company.hooks"
import { gobdNonCompliantDates } from "Shared/utils/date.utils"
import { getPopupAnchor } from "Shared/utils/popup.utils"

import { NotificationService } from "../../../../../shared/services"
import { patchExpense } from "../../../../../shared/store/actions/expense/expenseActions"
import { PostingPeriodInfoTooltip } from "../auxiliary/postingPeriodInfoTooltip"

interface PostingPeriodFormProps {
    expense: Expense
    setIsExpenseUpdating?: React.Dispatch<React.SetStateAction<boolean>>
    editable: boolean
    isLoading?: boolean
}

export const PostingPeriodField = ({ expense, setIsExpenseUpdating, editable, isLoading }: PostingPeriodFormProps) => {
    const { t } = useTranslation()
    const dispatch = useDispatch()

    const company = useCompany()
    const postingPeriod = expense.postingPeriod ? moment(expense.postingPeriod) : null

    if (!company.gobdCompliance?.enforceGobdCompliantInvoice) {
        return null
    }

    const onPostingPeriodChange = async (value: any) => {
        try {
            const postingPeriod = value ? value.startOf("month") : null
            await patchExpense(expense.id, { postingPeriod })(dispatch)
        } catch (err) {
            NotificationService.showErrorNotificationBasedOnResponseError(err, t("error:request.edit.title"))
        } finally {
            setIsExpenseUpdating?.(false)
        }
    }

    if (!editable || expense.isGobdCompliantInvoice()) {
        return (
            <li>
                <span className="title">
                    <div className="flex">
                        {t("label:posting_period")}
                        <PostingPeriodInfoTooltip />
                    </div>
                </span>
                <span className="text">{expense.postingPeriod ? moment(expense.postingPeriod).format("YYYY-MM") : "-"}</span>
            </li>
        )
    }

    return (
        <li>
            <span className="w-1/2 title">
                <div className="flex label-required">
                    {t("label:posting_period")}
                    <PostingPeriodInfoTooltip />
                </div>
            </span>

            <DatePicker
                className="w-1/2"
                picker="month"
                value={postingPeriod}
                format={t("label:date_format.month_year")}
                disabledDate={gobdNonCompliantDates}
                placeholder={t("placeholder:request.date_format.month_year")}
                onChange={onPostingPeriodChange}
                getPopupContainer={getPopupAnchor()}
                disabled={isLoading}
            />
        </li>
    )
}
